import React, { useContext, useEffect } from 'react'
import Layout from '../Layout'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import Standalone from '../../../Component/SlidePanel/Standalone'
import './ProductViewStandalone.css'

const ProductView = () => {
    return (
        <Layout>
            <div className="productViewStandalone customContainer">
                {/* <MultisellerSlider viewPage={true} /> */}
                <Standalone />
            </div>
        </Layout>
    )
}

export default ProductView
